$ = jQuery;


// Base preload effect
var isLoaded = false;

$(window).on('load', function () {
	if (!isLoaded) {
		loadPage();
	}
});

setTimeout(function () {
	if (!isLoaded) {
		loadPage();
	}
}, 500);

function loadPage() {
	isLoaded = true;
	$('body').removeClass('preload');
}

$(document).ready(function ($) {
	"use strict";
	$('.hamburger').click(function () {
		let $this = $(this);
		$(this).toggleClass('is-active');
		$('body, html').toggleClass('menu-active');
		$('.main-navigation').toggleClass('toggled');
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > 150) {
			$('body').addClass('scroll');
		} else {
			$('body').removeClass('scroll');
		}
	});

	//Open submenu on mobile

	$('#primary-menu > .menu-item-has-children').click(function (e) {
		console.log('ok');
		if ($(e.target).parent().hasClass('menu')) {
			$(this).toggleClass('open');

			if ($(this).hasClass('open')) {
				$(this).find('> ul').slideDown();
			} else {
				$(this).find('> ul').slideUp();
			}
		}
	});

	$('.sub-menu > .menu-item-has-children').click(function (e) {
		if ($(e.target).parent().hasClass('sub-menu')) {

			$(this).toggleClass('open');

			if ($(this).hasClass('open')) {
				$(this).find('> ul').slideDown();
			} else {
				$(this).find('> ul').slideUp();
			}
		}
	});

	// video Youtube play  -------- page reviews

	$('.video-btn').on('click', function(){
		var iframe = $(this).next('iframe');
		$(this).addClass('show');
		iframe.attr('src', iframe.data('src'));
	});


	// DATEPICKER

	// $(".datechk").datepicker();

	//FAQ

	$('.js-faq-title').click(function () {
		$(this).toggleClass('open');
		$(this).parent().toggleClass('open');
		if ($(this).hasClass('open')) {
			$(this).next().slideDown();
		} else {
			$(this).next().slideUp();
		}
	});

	$('form').find("input[name=gmautocomplete-649], input[name=gmautocomplete-138]").each(function (ev) {
		if (!$(this).val()) {
			$(this).attr("placeholder", "Origin Full Address");
		}
	});
	$('form').find("input[name=gmautocomplete-359], input[name=gmautocomplete-585]").each(function (ev) {
		if (!$(this).val()) {
			$(this).attr("placeholder", "Destination Full Address");
		}
	});

	// Fancybox
	if ($('[data-fancybox]')[0]){
		Fancybox.bind('[data-fancybox]', {
			//
		});
	}

	$('#phone-number').keydown(function (e) {
		var key = e.which || e.charCode || e.keyCode || 0;
		var $phone = $(this);
	
		if ($phone.val().length === 1 && (key === 8 || key === 46)) {
			$phone.val('('); 
			return false;
		} 
	
		else if ($phone.val().charAt(0) !== '(') {
			$phone.val('('+String.fromCharCode(e.keyCode)+''); 
		}
	
		if (key !== 8 && key !== 9) {
		if ($phone.val().length === 4) {
			$phone.val($phone.val() + ')');
		}
		if ($phone.val().length === 5) {
			$phone.val($phone.val() + ' ');
		}			
		if ($phone.val().length === 9) {
			$phone.val($phone.val() + '-');
		}
		}
	
		return (key == 8 || 
			key == 9 ||
			key == 46 ||
			(key >= 48 && key <= 57) ||
			(key >= 96 && key <= 105));	
	});
	
	$('#phone-number').bind('focus click', function () {
		var $phone = $(this);
	
		if ($phone.val().length === 0) {
			$phone.val('(');
		}
		else {
		var val = $phone.val();
			$phone.val('').val(val); 
		}
	});
	
	$('#phone-number').blur(function () {
		var $phone = $(this);
	
		if ($phone.val() === '(') {
			$phone.val('');
		}
	});

});

//datepicker init
let datePickers = document.querySelectorAll('.js-date-picker-x');
console.log(datePickers);
datePickers.forEach(eL =>{
  eL.DatePickerX.init({
    minDate: function()
    {
      var date = new Date();
      return new Date().setDate(date.getDate());
    },
    mondayFirst: false,
    format: 'mm/dd/yyyy'
  });
});